import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from '@material-ui/core';
import {PrimaryButton, SecondaryButton} from '../common/StyledButtons';
import {Grid} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { withRouter } from 'react-router-dom';
import {connect} from 'react-redux';
import {buildQueryString, formatQuizAnswersForBackend} from '../../utils/common';
import {postInstance, submitAnswer} from '../../api'; 
function QuizStartConfirm(props, context) {
    const {match: {params: {quizId}}, location:{state: {quizDataDict, userURLParams, answers, language}}} = props;
    const {router} = context;
    const handleStartOver = () => {
        submitAnswer(quizId, quizDataDict._id.$oid,
            formatQuizAnswersForBackend(answers)).then((response) => {
            sessionStorage.removeItem('currentIndex');
            postInstance(quizId, 0, quizDataDict._id.$oid);
            router.history.push({
                pathname: `/quizzes/${quizId}/take`,
                search:`?${buildQueryString(userURLParams)}`,
                state: {language: language},
            });
        });
    };

    const handleResume = () => {
        router.history.push({
            pathname: `/quizzes/${quizId}/take`,
            search:`?${buildQueryString(userURLParams)}`,
            state: {language: language},
        });
    };
    return (
        <div className="quiz-confirm-screen">
            <Box height="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                <Typography variant="body1" gutterBottom>
                    {
                        language === 'fr' ? 
                            'Vous êtes sur le point d\'effacer vos progrès et de commencer par le début, ce processus ne peut pas être annulé. Êtes-vous toujours sûr de vouloir recommencer?' :
                            'You are about to erase your progress and start from the beginning, this process cannot be reverted. Are you still sure you would like to start over?'
                    }
                </Typography>
                <Box mt={2}>
                    <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="center"
                    >
                        <PrimaryButton onClick={handleResume}>
                            {
                                language === 'fr' ? 'Non, reviens' : 'No, go back'
                            } 
                        </PrimaryButton>
                        <SecondaryButton onClick={handleStartOver}>
                            {
                                language === 'fr' ? 'Oui, commencez par le début' : 'Yes, start over from the beginning'
                            }
                        </SecondaryButton>
                    </Grid>
                </Box>
            </Box>
        </div>
    );
}

QuizStartConfirm.contextTypes = {
    router: PropTypes.object.isRequired
};

export default withRouter(connect(
    null,
    null
)(QuizStartConfirm));